import { render, staticRenderFns } from "./QuestionDetailView.vue?vue&type=template&id=590a64f9&"
import script from "./QuestionDetailView.vue?vue&type=script&lang=js&"
export * from "./QuestionDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {QuestionDetailItem: require('/lasso/components/questions/QuestionDetailItem.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('590a64f9')) {
      api.createRecord('590a64f9', component.options)
    } else {
      api.reload('590a64f9', component.options)
    }
    module.hot.accept("./QuestionDetailView.vue?vue&type=template&id=590a64f9&", function () {
      api.rerender('590a64f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/questions/QuestionDetailView.vue"
export default component.exports